/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Persona } from './Persona';
import {
    PersonaFromJSON,
    PersonaFromJSONTyped,
    PersonaToJSON,
    PersonaToJSONTyped,
} from './Persona';
import type { WsMember } from './WsMember';
import {
    WsMemberFromJSON,
    WsMemberFromJSONTyped,
    WsMemberToJSON,
    WsMemberToJSONTyped,
} from './WsMember';

/**
 * 
 * @export
 * @interface Options
 */
export interface Options {
    /**
     * List of persona IDs set as default assignees for chat conversations
     * @type {Array<Persona>}
     * @memberof Options
     */
    defaultAssignees: Array<Persona>;
    /**
     * List of workspace members who receive default email notifications
     * @type {Array<WsMember>}
     * @memberof Options
     */
    defaultEmailNotification: Array<WsMember>;
    /**
     * Delay in minutes before sending an email notification about a new chat message (-1 to disable)
     * @type {number}
     * @memberof Options
     */
    defaultEmailDelay: number;
    /**
     * Inactivity limit in minutes before a conversation is considered inactive (-1 to disable)
     * @type {number}
     * @memberof Options
     */
    defaultInactivityLimit: number;
    /**
     * Whether to send an email to the client about unread messages
     * @type {boolean}
     * @memberof Options
     */
    emailClientsAboutUnreadMessages: boolean;
}

/**
 * Check if a given object implements the Options interface.
 */
export function instanceOfOptions(value: object): value is Options {
    if (!('defaultAssignees' in value) || value['defaultAssignees'] === undefined) return false;
    if (!('defaultEmailNotification' in value) || value['defaultEmailNotification'] === undefined) return false;
    if (!('defaultEmailDelay' in value) || value['defaultEmailDelay'] === undefined) return false;
    if (!('defaultInactivityLimit' in value) || value['defaultInactivityLimit'] === undefined) return false;
    if (!('emailClientsAboutUnreadMessages' in value) || value['emailClientsAboutUnreadMessages'] === undefined) return false;
    return true;
}

export function OptionsFromJSON(json: any): Options {
    return OptionsFromJSONTyped(json, false);
}

export function OptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Options {
    if (json == null) {
        return json;
    }
    return {
        
        'defaultAssignees': ((json['defaultAssignees'] as Array<any>).map(PersonaFromJSON)),
        'defaultEmailNotification': ((json['defaultEmailNotification'] as Array<any>).map(WsMemberFromJSON)),
        'defaultEmailDelay': json['defaultEmailDelay'],
        'defaultInactivityLimit': json['defaultInactivityLimit'],
        'emailClientsAboutUnreadMessages': json['emailClientsAboutUnreadMessages'],
    };
}

export function OptionsToJSON(json: any): Options {
    return OptionsToJSONTyped(json, false);
}

export function OptionsToJSONTyped(value?: Options | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'defaultAssignees': ((value['defaultAssignees'] as Array<any>).map(PersonaToJSON)),
        'defaultEmailNotification': ((value['defaultEmailNotification'] as Array<any>).map(WsMemberToJSON)),
        'defaultEmailDelay': value['defaultEmailDelay'],
        'defaultInactivityLimit': value['defaultInactivityLimit'],
        'emailClientsAboutUnreadMessages': value['emailClientsAboutUnreadMessages'],
    };
}

